// Add this at the beginning of the file to suppress source map warnings
if (import.meta.env.DEV && import.meta.env.VITE_SUPPRESS_WARNINGS === 'true') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (args[0]?.includes('source map') || args[0]?.includes('sourcemap')) {
      return;
    }
    originalConsoleError(...args);
  };
}

import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import App from './App.tsx'
import './index.css'

// Fix the syntax error in the render call
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
